import * as yup from "yup";

export default yup.string().ensure().trim().label("Context");
